(() => {
  if (document.documentElement.hasAttribute('data-catalog-static') || window.maisonScrollMotion) return;
  window.maisonScrollMotion = true;
  const script = document.currentScript;
  const duration = Math.max(250, Math.min(900, Number(script?.dataset.duration) || 450));
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const enabled = () => !preference.matches && !window.Shopify?.designMode && parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--maison-motion')) > 0;
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const selector = '.pc-heading, .pc-card, .ta-intro, .maison-editorial-band, .mx-intro, .md-figure, .md-content, .maison-editorial__copy, .tm-contact-form, .tm-contact-info';
  let seen = new WeakSet();
  const active = new Map();
  const reveal = target => {
    observer.unobserve(target);
    const animation = active.get(target);
    active.delete(target);
    animation?.cancel();
  };
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const target = entry.target;
      observer.unobserve(target);
      if (!enabled() || target.contains(document.activeElement)) {
        reveal(target);
        continue;
      }
      active.get(target)?.play();
    }
  }, { threshold: 0, rootMargin: '0px 0px 48px 0px' });
  function scan(root = document) {
    if (!enabled()) return;
    const nodes = [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
    for (const node of nodes) {
      if (seen.has(node)) continue;
      seen.add(node);
      const bounds = node.getBoundingClientRect();
      if (!bounds.width || !bounds.height || bounds.top < innerHeight + 48 || node.contains(document.activeElement)) continue;
      const animation = node.animate([
        { opacity: 0, transform: 'translate3d(0, 8px, 0)' },
        { opacity: 1, transform: 'translate3d(0, 0, 0)' }
      ], { duration, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' });
      animation.pause();
      animation.currentTime = 0;
      active.set(node, animation);
      animation.finished.then(
        () => { if (active.get(node) === animation) reveal(node); },
        () => { if (active.get(node) === animation) active.delete(node); }
      );
      observer.observe(node);
    }
  }
  const finish = root => {
    for (const node of [...active.keys()]) {
      if (root.contains(node) || node.contains(root)) reveal(node);
    }
  };
  function start() {
    scan();
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => finish(event.target));
    document.addEventListener('shopify:block:select', event => finish(event.target));
    document.addEventListener('focusin', event => finish(event.target));
    preference.addEventListener('change', () => {
      observer.disconnect();
      for (const node of [...active.keys()]) reveal(node);
      if (!preference.matches) {
        seen = new WeakSet();
        scan();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
